import { useIsAuthenticated, useMsal } from '@azure/msal-react';

/**
 * Custom hook to get the agent's name.
 * @returns The agent's name if available, otherwise null.
 * @example
 */
export const useAgentName = (): string | null => {
  const isAuthenticated = useIsAuthenticated();
  const { accounts } = useMsal();
  /**
   * @returns username from localStorage, or null if missing/corrupted
   * @example getStoredUsername()
   */
  const getStoredUsername = (): string | null => {
    try {
      const raw = localStorage.getItem('credentials');
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return parsed?.username?.trim() || null;
    } catch {
      return null;
    }
  };

  const name = isAuthenticated
    ? accounts[0]?.username?.trim()
    : getStoredUsername();

  return name || null;
};
